import { ConnectionCard } from './ConnectionCard'
import { SupportCard } from './SupportCard'

export const InformationSection = () => (
  <>
    <ConnectionCard />
    <SupportCard />
  </>
)
